import { clsx, type ClassValue } from 'clsx'
import { twMerge } from 'tailwind-merge'

/**
 * Join class names, with later Tailwind utilities winning over earlier conflicting ones.
 *
 * `clsx` handles conditionals and arrays; `twMerge` resolves conflicts, so a component's default
 * `px-md` is genuinely overridden by a caller's `px-lg` instead of both landing in the class list
 * and the winner being decided by stylesheet order.
 *
 * Both packages are already dependencies across the platform and, until now, unused.
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs))
}
